<template>
    <div class="animated fadeIn">
        <b-modal ref="modal-newRule" scrollable centered button-size="sm" v-on:hide="hideModal" v-on:close="hideModal">
            <template #modal-title>
                <i class="fas fa-random"></i>&nbsp; NOVA REGRA
            </template>
            <div class="newRule__inputs__container">
                <NxInput
                  validation="min:1"
                  :validation-messages="{
                      min: 'Valor deve ser maior que zero.'
                  }"
                  error-behavior="value"
                  required
                  name="timeLimit"
                  type="number"
                  label="Dias em atraso"
                  placeholder="Digite os dias em atraso"
                  :value="form.daysOverdue"
                  v-model="form.daysOverdue">
                </NxInput>
                <NxSelectQuadroColunaTransferencia
                  required
                  :value="form.boardDestinationId"
                  :boardId="boardObj.id"
                  :onlyActive="true"
                  @update:value="form.boardDestinationId = $event" />
            </div>
            <template #modal-footer>
                <div class="w-100 text-right">
                    <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Clear }}</span></button>&nbsp;
                    <button :disabled="!readyToSave" type="button" class="btn rounded btn-third btn-sm" v-on:click="onSave"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"> <i class="fas fa-check-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Save }}</span></button>&nbsp;
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { NxSelectQuadroColunaTransferencia } from '@/components/nexum/components/custom-selects/index.js'
import { toast } from '@/shared/utils/UIHelper'
import TransfAutoCardRepository from '@/shared/http/repositories/crm/transferenciaAutoCard.js'

export default {
  name: 'ModalNewTransferencia',
  props: {
    boardObj: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        daysOverdue: null,
        boardDestatinationId: null,
        isActive: false
      }
    }
  },
  components: { NxSelectQuadroColunaTransferencia },
  computed: {
    readyToSave () {
      return this.form && this.form.daysOverdue
    }
  },
  mounted () {
    if (this.isEditing) {
      this.dataToForm()
    }
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-newRule'].show()
    },
    hideModal () {
      this.$emit('HideModal')
    },
    hideModalSucess () {
      this.$emit('Reload')
    },
    onSave () {
      if (this.isEditing) {
        this.onEdit()
        return
      }

      let data = this.formatData()
      let idCurrentBoard = this.boardObj.id
      TransfAutoCardRepository.Create(idCurrentBoard, data)
        .then(() => {
          toast.success('A regra foi salva com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível salvar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onEdit () {
      let data = this.formatData()
      TransfAutoCardRepository.Update(data)
        .then(() => {
          toast.success('A regra foi editada com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível editar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onClear () {
      this.$root.$emit('clearForm')
    },
    formatData () {
      let days = parseInt(this.form.daysOverdue)
      let bcId = parseInt(this.form.boardDestinationId)

      let data = {
        boardDestinationId: bcId,
        daysOverdue: days,
        isActive: this.form.isActive,
        id: this.form.id ? this.form.id : null
      }
      return data
    },
    dataToForm () {
      this.form = {
        daysOverdue: this.isEditing.daysOverdue,
        isActive: this.isEditing.isActive,
        boardDestinationId: this.isEditing.boardDestinationId,
        id: this.isEditing.id
      }
    }
  }
}

</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
    max-width: 100% !important;
}

.newRule__inputs__container {
    display: flex;
    gap: 1rem;
    justify-content: space-between;

    .formulate-input {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-quadro/ModalNewTransferencia.vue